import { render, staticRenderFns } from "./MedicalProcedures.vue?vue&type=template&id=1130345f"
import script from "./MedicalProcedures.vue?vue&type=script&lang=ts"
export * from "./MedicalProcedures.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports